import React from 'react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <section className="py-20 bg-brand-navy text-white px-6" data-id="element-136">
      <div className="max-w-4xl mx-auto" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-139">
            Presentando: El Protocolo PISR
          </h2>
          <p className="text-xl md:text-2xl text-brand-sage-light font-serif italic" data-id="element-140">
            (Intervención Somática Rápida)
          </p>
        </motion.div>

        <div className="space-y-8 text-lg md:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto text-center" data-id="element-141">
          <p className="font-medium text-brand-sage-light" data-id="element-142">
            No es un curso de psicología de 6 meses. Es un botón de reinicio
            biológico.
          </p>

          <p data-id="element-143">
            He diseñado este método basándome en una verdad científica simple:
          </p>

          <blockquote className="my-12 py-8 px-6 bg-white/5 rounded-2xl border border-white/10" data-id="element-144">
            <p className="font-serif text-2xl md:text-3xl italic text-brand-sage-light font-medium leading-snug" data-id="element-145">
              "El cuerpo puede calmar al cerebro mucho más rápido de lo que las
              palabras pueden hacerlo."
            </p>
          </blockquote>

          <p data-id="element-146">
            Con el Método de los 90 Segundos, no intentas "educar" durante la
            crisis. Usas hackeos sensoriales específicos —presión profunda,
            reducción de estímulos y anclajes rítmicos— para apagar la señal de
            alarma del cerebro de tu hijo. Es como bajar el interruptor de una
            alarma de incendios que se quedó pegada.
          </p>
        </div>

        <div className="mt-20 max-w-2xl mx-auto" data-id="element-147">
          <div className="flex justify-between items-center relative" data-id="element-148">
            <div className="absolute left-0 right-0 top-1/2 h-0.5 bg-white/20 -z-10" data-id="element-149"></div>
            {[{
            time: '30s',
            label: 'Conexión'
          }, {
            time: '60s',
            label: 'Regulación'
          }, {
            time: '90s',
            label: 'Calma'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="flex flex-col items-center gap-4" data-id="element-150">
                <div className="w-16 h-16 rounded-full bg-brand-sage flex items-center justify-center text-xl font-bold shadow-[0_0_20px_rgba(122,148,116,0.4)]" data-id="element-151">
                  {step.time}
                </div>
                <span className="font-serif italic text-white/80" data-id="element-152">
                  {step.label}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}